var EN = EN || {};

(function($, document) {
  'use strict';

  $(document).on('ready', function() {
    /**
     * Hash and target element must exist.
     * If user started scrolling already, don't apply the effect or it might cause a jump
     */
    if (EN.pageHash && $('#' + EN.pageHash).length && $(window).scrollTop() === 0) {
      if (getComputedStyle(document.body).scrollBehavior === 'smooth') {
        window.location.hash = EN.pageHash;
      } else {
        $('html, body').animate(
          {
            scrollTop: $('#' + EN.pageHash).offset().top,
          },
          2000,
          'swing'
        );
      }
    }
  });

  // backend data
  var configJson = $('#wpen-backend-json').attr('content');
  EN.config = configJson ? $.parseJSON(configJson) : {};

  EN.DomHelper.setCapabilityClasses();
  EN.DomHelper.initCheckboxHighlander();
  $('.en-checkbox-input').change(function() {
    var $parent = $(this).parents('.en-checkbox-target');
    $parent.toggleClass('en-is-checked');
  });

  //to close the Ninja Form popup
  $(document).on('click', '.en-ninja-close, .en-ninja-close input[type="button"]', function(e) {
    e.preventDefault();

    var $close = $(this)
      .parents('.en-layover')
      .find('.en-layover__close');
    if (typeof $close !== 'undefined') {
      $close.trigger('click');
    }
  });
  $(document).on('click', '.en-success-box__close', function(e) {
    var $parent = $(this).parents('.en-success-box');
    $parent.removeClass('en-is-active');
  });

  $(document).on('click', '.en-js-print', function() {
    window.print();
  });

  $(document).on('click', '.en-js-scroll', function() {
    var windowHeight = $(window).height();
    console.log(windowHeight);
    $('html, body').animate({ scrollTop: windowHeight }, 1000);
  });

  /**
   * Helper functions
   * @memberof module:ScrollAnimation
   */
  var getViewportWidth = function() {
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  };

  // ready
  $(function() {
    EN.ScrollingAnimations.init();
    EN.ClassClick.init({
      checkOutsiders: true,
    });

    EN.Lightbox.init();
    //EN.Forms.init();
    EN.Podcasts.init();
    //EN.Forms.initAjax();
    EN.PhotoSwipe.init();

    // EN.Box.init();
    // EN.Tabs.init();
    // Initializing custom modules
    EN.Slider.init();
    EN.Sticky.init();
    EN.ScrollSpy.init();
    EN.ArchiveSticky.init();
    EN.BatchProcessor.init();
    EN.ClickableTeaser.init();
    // new EN.InView($('.en-in-view-element'));
    // EN.AnchorNav.init($('.en-anchor'));

    $('#blogoverview').packery({
      // options
      itemSelector: '.en-griditem',
      gutter: 0,
    });

    var $navSearchInput = $('.en-nav__search');
    $(document).on('click', '.en-nav__toggle', function() {
      if (getViewportWidth() > 719) {
        $navSearchInput.focus();
      }
    });

    // list
    var $lists = $('.en-mdl-list[data-en-mdl-ajax-data]');
    $lists.each(function() {
      var $list = $(this);
      var list = new EN.List($list);
      $list.data('EnList', list);
    });

    EN.CookieNotification.init({
      cookieName: EN.config.cookieNameBugmenot,
    });

    /**
     * Load Tracker Scripts
     * Scripts will be loaded if the privacy cookie is set to allow it (true)
     * or the site does not use a the privacy notification plugin
     */
    if (!EN.privacyNotification || EN.privacyNotification.isAccepted()) {
      if (EN.config.googleAnalytics) {
        if (EN.config.googleAnalytics.trackingCodeStyle === 'gtm') {
          EN.TrackingHelper.insertGoogleTagManagerCode(EN.config.googleAnalytics.webPropertyId);
        } else {
          EN.TrackingHelper.insertGoogleAnalyticsCode(EN.config.googleAnalytics);
        }

        // enable event tracking
        // EN.TrackingHelper.initAttributeBasedEventTracking();
      }

      if (EN.config.facebook && EN.config.facebook.id) {
        EN.TrackingHelper.insertFacebookPixelCode(EN.config.facebook.id);
      }

      if (EN.config.addthis && EN.config.addthis.id) {
        EN.TrackingHelper.insertAddThisCode(EN.config.addthis.id);
      }
    }

    /* TO DO: MOVE THIS SOMEWHERE ELSE>>> */
    $('.en-history-era__show-all').on('click', function() {
      var $clickedShowMoreButton = $(this);
      var $parentOfEvents = $clickedShowMoreButton.parent();
      var ajaxUrl = $(this).data('en-call');
      var eraId = $(this).data('en-era-id');
      var eraCurrentPage = $(this).data('en-era-current-page'); // page because of 'paged' parameter
      var eraEventsShown = $(this).data('en-era-events-shown');

      $.ajax({
        url: ajaxUrl,
        dataType: 'json',
        data: {
          action: 'load_more_era_events',
          en_era_id: eraId,
          en_era_current_page: eraCurrentPage,
          en_era_events_shown: eraEventsShown,
        },
        success: function(data) {
          data.posts.forEach(function(item) {
            $clickedShowMoreButton.remove();
            $parentOfEvents.append(item.post_html);
          });
          $parentOfEvents.append(data.btn_toggle_era_events);
        },
      });
    });

    $(document).on('click', '.en-history-era__toggle-all', function() {
      var hideLanguageString = $(this).data('en-hide-lang-string');
      var showLanguageString = $(this).data('en-show-lang-string');
      if ($(this).hasClass('en-is-folded')) {
        $(this).text(showLanguageString);
      } else {
        $(this).text(hideLanguageString);
      }
    });
    /* <<<MOVE THIS SOMEHERE ELSE; */
  });
})(jQuery, document);

// Browser alert
var showBrowserAlert = function() {
  if (document.querySelector('.en-unsupported-browser__content')) {
    var is_IE11 = /Trident\/|MSIE/.test(window.navigator.userAgent);
    if (!is_IE11) {
      return;
    }
    var d = document.getElementsByClassName('en-unsupported-browser__content');
    /*
		var language = /\/en\//.test(window.location) ? 'en' : 'de';
		var msg_de = '<b>Browser nicht unterstützt!</b> \
			Mit diesm Browser ist die Seite nur eingeschraenkt bedienbar. \
			Bitte verwenden sie eine aktuelle Version von Chrome, Firefox, Safari, oder Edge.';
		var msg_en = '<b>Unsupported Browser!</b> \
			This website will offer limited functionality in this browser. \
			We only support the recent versions of major browsers like Chrome, Firefox, Safari, and Edge.'
		*/
    d[0].innerHTML = EN.config.translationStrings.unsupported_browser;
    // d[0].style.display = 'block';
    $('.en-unsupported-browser').css({
      display: 'block',
      top: $('.en-header').height(),
    });

    $(window).on('resize', function() {
      $('.en-unsupported-browser').css({
        top: $('.en-header').height(),
      });
    });
  }
};
document.addEventListener('DOMContentLoaded', showBrowserAlert);
// ./ Browser alert
